import React from 'react';
import styled from '@emotion/styled';
import Skeleton from '@/components/@IntranetLibrary/Skeleton';
import ImageWithErrorHandling from '@/components/ImageWithErrorHandling';
import Checkbox from '@/components/@IntranetLibrary/Checkbox';
import { imgUrlChk } from '@/utils/function';
import HighlightedText from '@/components/Approval/Common/HighlightedText';
import { resolveDepartmentName } from '@/utils/approval/ceoAffiliation';

interface PassportCheckItemProps {
  passportId: string;
  name: string;
  positionName?: string;
  divisionName?: string;
  departmentName?: string;
  profileImageUrl?: string;
  isChecked: boolean;
  onClick?: () => void;
  style?: React.CSSProperties;
  /** 검색어 — 이름에서 매칭 부분을 파랑으로 하이라이트 */
  keyword?: string;
}

const PassportCheckItem = ({
  passportId,
  name,
  positionName,
  divisionName,
  departmentName,
  profileImageUrl,
  isChecked,
  onClick,
  style,
  keyword,
}: PassportCheckItemProps) => {
  return (
    <Container className={'v2cb-hover-target'} onClick={onClick} style={style}>
      <Checkbox checked={isChecked} onClick={onClick} sx={{ padding: 0 }} />
      {profileImageUrl ? (
        <ImageWithErrorHandling
          style={{ borderRadius: '50%', objectFit: 'cover' }}
          width={40}
          height={40}
          src={imgUrlChk(profileImageUrl)}
          alt={`${passportId}-profile`}
          errorImage={'/images/dummy/default-profile.svg'}
        />
      ) : (
        <Skeleton variant={'circle'} width={40} height={40} />
      )}
      <InfoWrapper>
        <NameText>
          <HighlightedText
            text={`${name} ${positionName ?? '-'}`}
            keyword={keyword}
          />
        </NameText>
        <DetailText>{`${divisionName} • ${resolveDepartmentName(
          { passportId, departmentName },
          departmentName,
        )}`}</DetailText>
      </InfoWrapper>
    </Container>
  );
};

export default PassportCheckItem;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: left;
  cursor: pointer;
  gap: 8px;
`;

const InfoWrapper = styled.div`
  width: 210px;
`;

const NameText = styled.div`
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  width: 100%;
  overflow-x: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const DetailText = styled.div`
  color: var(--dk-text-secondary, #888d96);
  font-size: 12px;
  line-height: 18px;
  width: 100%;
  overflow-x: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
